module.exports = __webpack_public_path__ + "img/top3@3x.8d03db9c.png";